import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as unknown as ScrollBehavior });
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: '关于6789影院 - 热门综艺节目免费在线观看平台',
      description: '6789影院成立于2024年，致力于为广大综艺爱好者提供最优质的免费综艺在线观看服务。收录全网热门综艺节目，高清流畅不缓冲。',
      url: 'https://www.6789cinema.com/about',
      isPartOf: {
        '@type': 'WebSite',
        name: '6789影院',
        url: 'https://www.6789cinema.com/',
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.6789cinema.com/' },
          { '@type': 'ListItem', position: 2, name: '关于我们' },
        ],
      },
      mainEntity: {
        '@type': 'Organization',
        name: '6789影院',
        url: 'https://www.6789cinema.com',
        description: '6789影院收录全网热门综艺节目，免费在线观看高清流畅不缓冲。综艺节目大全每日更新。',
        foundingDate: '2024',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          email: 'contact@6789cinema.com',
        },
      },
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Breadcrumb items={[
          { label: '首页', href: '/' },
          { label: '关于我们' },
        ]} />

        <section className="px-4 md:px-6 pb-14 md:pb-16">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 text-center">
              关于6789影院
            </h1>
            <p className="mt-4 text-sm md:text-base text-foreground-500 text-center leading-relaxed">
              6789影院——您的一站式综艺节目免费在线观看平台
            </p>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-label="品牌介绍">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
              品牌介绍
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                6789影院成立于2024年，是一个专注于综艺节目在线观看的综合性平台。我们致力于为广大综艺爱好者提供最全面、最及时、最高清的综艺节目资源，让每一位用户都能享受到流畅舒适的观看体验。
              </p>
              <p>
                我们的核心理念是<strong>免费、高清、便捷</strong>。在6789影院，您无需注册、无需付费、无需安装任何插件，打开网页即可畅享数千部热门综艺节目。从爆笑综艺到音乐选秀，从真人秀到谈话节目，综艺节目大全应有尽有。
              </p>
              <p>
                6789影院团队由一群热爱综艺内容的年轻人组成。我们深知观众对优质综艺内容的需求，因此投入了大量精力进行资源整合和技术优化，确保平台上的每一部综艺节目都能以最佳画质呈现，播放流畅不缓冲，真正实现即点即播。
              </p>
              <p>
                我们持续追踪全网热门综艺动态，每日更新节目内容，确保您不会错过任何精彩瞬间。无论您喜欢什么样的综艺类型，6789影院都能满足您的观看需求。
              </p>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14" aria-label="平台优势">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
              为什么选择6789影院
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
              {[
                { icon: 'ri-vip-diamond-line', title: '完全免费', desc: '所有综艺节目免费在线观看，无隐藏收费，无会员门槛' },
                { icon: 'ri-4k-line', title: '高清画质', desc: '采用先进视频编码技术，提供高清流畅的观看体验' },
                { icon: 'ri-flashlight-line', title: '即点即播', desc: '无需安装插件或播放器，打开网页就能直接观看' },
                { icon: 'ri-refresh-line', title: '每日更新', desc: '紧跟播出节奏，第一时间更新最新综艺节目内容' },
                { icon: 'ri-smartphone-line', title: '多端适配', desc: '全面支持电脑、平板、手机等多种设备流畅观看' },
                { icon: 'ri-shield-check-line', title: '安全可靠', desc: '合法合规运营，保护用户隐私，打造安全的观看环境' },
              ].map((item, index) => (
                <div key={index} className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-100">
                    <i className={`${item.icon} text-primary-600 text-lg md:text-xl`}></i>
                  </div>
                  <h3 className="mt-4 text-base font-heading font-semibold text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-label="用户口碑">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              {[
                { name: '小王', role: '综艺达人', content: '一直在用6789影院看综艺，更新快画质好，关键是完全免费，强烈推荐给身边的朋友！' },
                { name: 'Linda', role: '追综少女', content: '最喜欢的综艺平台没有之一！分类清晰，找节目很方便，播放流畅从来不卡顿。' },
                { name: '老李', role: '退休教师', content: '儿子推荐我用6789影院看综艺，操作简单，画面清晰，退休生活多了很多乐趣。' },
              ].map((review, index) => (
                <div key={index} className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map(star => (
                      <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    "{review.content}"
                  </p>
                  <div className="mt-4 flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-primary-600 text-sm font-medium">{review.name[0]}</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{review.name}</p>
                      <p className="text-xs text-foreground-500">{review.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14" aria-label="联系我们">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              <div className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-primary-600 text-lg"></i>
                </div>
                <h3 className="mt-4 text-sm font-heading font-semibold text-foreground-900">电子邮箱</h3>
                <a href="mailto:contact@6789cinema.com" className="mt-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors">
                  contact@6789cinema.com
                </a>
              </div>
              <div className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-wechat-line text-accent-600 text-lg"></i>
                </div>
                <h3 className="mt-4 text-sm font-heading font-semibold text-foreground-900">微信公众号</h3>
                <p className="mt-1.5 text-sm text-foreground-500">6789影院官方</p>
              </div>
              <div className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-customer-service-2-line text-secondary-600 text-lg"></i>
                </div>
                <h3 className="mt-4 text-sm font-heading font-semibold text-foreground-900">在线客服</h3>
                <p className="mt-1.5 text-sm text-foreground-500">工作日 9:00-18:00</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}